export enum OptionDataType {
    Boolean,
    Number,
    Select,
    String,
}